import React, { useState } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import './LunaCalendar.css';

const localizer = momentLocalizer(moment);

function LunaCalendar() {
  const [events, setEvents] = useState([
    {
      title: 'Event 1',
      start: new Date(),
      end: new Date(),
      location: 'Location 1',
      note: 'Note 1',
    },
    {
      title: 'Event 2',
      start: new Date(),
      end: new Date(),
      location: 'Location 2',
      note: 'Note 2',
    },
    // Ajoutez d'autres événements ici
  ]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [newEvent, setNewEvent] = useState({
    title: '',
    start: '',
    end: '',
    location: '',
    note: '',
  });

  

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleAddEvent = () => {
    if (selectedEvent) {
      // Modifier l'événement existant
      const updatedEvents = events.map((event) =>
        event === selectedEvent ? { ...event, ...newEvent } : event
      );
      setEvents(updatedEvents);
    } else {
      // Ajouter un nouvel événement
      setEvents((prevEvents) => [...prevEvents, newEvent]);
    }

    handleCloseModal();
    setSelectedEvent(null);
    setNewEvent({
      title: '',
      start: '',
      end: '',
      location: '',
      note: '',
    });
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setNewEvent((prevEvent) => ({
      ...prevEvent,
      [name]: value,
    }));
  };

  const handleEventDrop = ({ event, start, end }) => {
    const updatedEvents = events.map((item) =>
      item === event
        ? {
            ...item,
            start,
            end: moment(item.end).add(moment(end).diff(moment(start))).toDate(),
          }
        : item
    );

    setEvents(updatedEvents);
  };

  const handleEventResize = ({ event, start, end }) => {
    const updatedEvents = events.map((item) =>
      item === event
        ? {
            ...item,
            start,
            end,
          }
        : item
    );

    setEvents(updatedEvents);
  };

  const handleSelectEvent = (event) => {
    setSelectedEvent(event);
    setIsModalOpen(true);
  };


  const handleDoubleClickEvent = ({ start }) => {
    const isSlotEmpty = !events.some((event) =>
      moment(start).isBetween(moment(event.start).subtract(1, 'minute'), event.end, null, '[]')
    );
  
    if (isSlotEmpty) {
      const newEvent = {
        title: 'Nouvel événement',
        start,
        end: moment(start).add(1, 'hour').toDate(),
        location: '',
        note: '',
      };
  
      setEvents((prevEvents) => [...prevEvents, newEvent]);
    }
  };
  
  
  
  return (
    <div style={{ height: '100vh', padding: '30px' }}>
      <div style={{ marginBottom: '10px' }} className='addEventBtn'>
        <AddIcon onClick={handleOpenModal} />
      </div>
      <Calendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        views={['month', 'week', 'day']}
        selectable
        onSelectEvent={handleSelectEvent}
        onEventDrop={handleEventDrop}
        onEventResize={handleEventResize}
        style={{ height: 'calc(100% - 50px)' }}
        onDoubleClick={handleDoubleClickEvent}

        
      />
      <Dialog open={isModalOpen} onClose={handleCloseModal}>
        <DialogTitle>{selectedEvent ? 'Modifier un événement' : 'Ajouter un événement'}</DialogTitle>
        <DialogContent>
          <TextField
            name="title"
            label="Titre"
            value={selectedEvent ? selectedEvent.title : newEvent.title}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
          />
          <TextField
            name="start"
            label="Date de début"
            type="datetime-local"
            value={selectedEvent ? moment(selectedEvent.start).format('YYYY-MM-DDTHH:mm') : newEvent.start}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
          />
          <TextField
            name="end"
            label="Date de fin"
            type="datetime-local"
            value={selectedEvent ? moment(selectedEvent.end).format('YYYY-MM-DDTHH:mm') : newEvent.end}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
          />
          <TextField
            name="location"
            label="Lieu"
            value={selectedEvent ? selectedEvent.location : newEvent.location}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
          />
          <TextField
            name="note"
            label="Note"
            value={selectedEvent ? selectedEvent.note : newEvent.note}
            onChange={handleInputChange}
            fullWidth
            multiline
            rows={3}
            margin="normal"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal}>Annuler</Button>
          <Button onClick={handleAddEvent}  variant="contained" color="primary" >
            {selectedEvent ? 'Modifier' : 'Ajouter'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default LunaCalendar;

